import { DataProxy } from 'apollo-cache'
import { removeFromPaginated } from 'utils'
import { addShareToLists } from '../../utils'

import { readShareListItemFromCache, writeShareListItemToCache } from '../utils'

export interface HandleShareRestoredProps {
  cache: DataProxy
  identifier: string
}

export const handleShareRestored = (props: HandleShareRestoredProps) => {
  const { cache, identifier } = props

  const share = readShareListItemFromCache({
    cache,
    id: identifier,
  })

  // even if the share is null here,
  // there still can be smaller fragments in the cache
  // let's remove all of them.
  removeFromPaginated(cache, { __typename: 'Share', identifier }, key =>
    key.includes('workspaceTrash')
  )

  if (!share) {
    return
  }

  if (share.deletedAt) {
    share.deletedAt = null
    writeShareListItemToCache({ cache, share: { ...share } })
  }

  addShareToLists(share, cache)
}
